import { render, staticRenderFns } from "./tab-6-record-buy.vue?vue&type=template&id=3821a2f5&scoped=true&lang=pug&"
import script from "./tab-6-record-buy.vue?vue&type=script&lang=js&"
export * from "./tab-6-record-buy.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3821a2f5",
  null
  
)

export default component.exports